import { Box, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import { Order, Settlement } from '../../../Models';
import { historyPriceFormatter } from '../../../utils/formatters';

type ProductsTableSectionProps = {
    order: Order;
    settlement: Settlement;
};
export default function ProductsTableSection({ order, settlement }: ProductsTableSectionProps) {
    const products = settlement.products.items;

    return (
        <Box>
            <Typography variant="subtitle1" gutterBottom>
                Productos
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Producto</TableCell>
                        <TableCell align="right">Cantidad</TableCell>
                        <TableCell align="right">Precio Unitario</TableCell>
                        <TableCell align="right">Dto.</TableCell>
                        <TableCell align="right">Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {products.map((product) => (
                        <TableRow key={product.name}>
                            <TableCell>{product.name}</TableCell>
                            <TableCell align="right">{product.quantity}</TableCell>
                            <TableCell align="right">
                                {historyPriceFormatter.format(product.unit_price / 100)}
                            </TableCell>
                            <TableCell align="right">{product.discount_percent}</TableCell>
                            <TableCell align="right">
                                {historyPriceFormatter.format(
                                    (product.quantity *
                                        product.unit_price *
                                        (1 - product.discount_percent / 100)) /
                                        100,
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                    {products.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                No hay productos
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Box>
    );
}
